import { MGHelperText } from "@/components/typography";
import { ErrorMessage } from "formik";
import MGColorPicker from "./MGColorPicker";
import MGField from "../BuildingBlocks/MGField";
import PropTypes from "prop-types";

export const MGColorPickerField = ({ name, onChange, disabled, inline }) => {
  return (
    <MGField name={name} inline={inline}>
      {({ meta, field, form }) => {
        const onChangeHandler = (evt) => {
          form.setFieldTouched(name, true);
          form.setFieldValue(field.name, evt);
          if (typeof onChange === "function") onChange(evt);
        };

        return (
          <>
            <MGColorPicker
              value={field.value}
              onChange={onChangeHandler}
              formikField={field}
              formikMeta={meta}
              disabled={disabled}
            />
            <ErrorMessage component={MGHelperText} name={name} />
          </>
        );
      }}
    </MGField>
  );
};
MGColorPickerField.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
};

export default MGColorPickerField;
